<template>
    <Head title="Users" />

    <BreezeAuthenticatedLayout>
      <main class="container">
        <div class="main mypage">

          <div class="c-header">
            <Link href="#" onclick="window.history.back(); return false;" class="c-header__back">
              <img src="/images/icons/icon-chevron-left.svg" alt="back">
            </Link>
            <h2 class="c-header--h2">プロフィールを編集</h2>
          </div>

          <form @submit.prevent="updateUser">
            <div class="mt-24">
              <label for="name">ニックネーム</label>
              <div class="mt-1">
                <input type="text" id="name" wire:model.lazy="name" name="name" v-model="form.name">
              </div>
            </div>
            <div class="mt-24">
              <label for="email">メールアドレス</label>
              <div class="mt-1">
                <input type="text" id="email" wire:model.lazy="email" name="email" v-model="form.email">
              </div>
            </div>

            <div class="mt-24">
              <button type="submit" class="c-button">変更する</button>
            </div>
          </form>

        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Inertia,
      Side,
    },

    setup(props) {
      const form = useForm({
        name: props.user.name,
        email: props.user.email,
        // image: props.user.image,
      });

      return { form };
    },

    props: {
      user: Object,
      // image: String
      // image:{
      //     type: String,
      // }
    },

    methods: {
      updateUser() {
        Inertia.post(`/users/${this.user.id}`, {
        _method: 'put',
        name: this.form.name,
        email: this.form.email,
        // image: this.form.image
      })
      // this.form.put(route("users.update", this.user.id));
      // },
    },
    }
  }
</script>
